import { FC, lazy, useEffect } from "react";
import useNav from "./useNav";
import { BUITheme } from "@blofin/blofin-ui";
import { createFooter } from "../Footer/entry";

const DevFooter = lazy(() => import("../Footer"));

const NavFooter: FC<{
  theme: BUITheme;
  apiConfig: { baseUrl: string };
  footerBgColor?: string;
  isSimple?: boolean;
  size?: "1280" | "1440";
}> = ({ theme, apiConfig, footerBgColor, isSimple = false, size }) => {
  const { sdkUrl, initFooter } = useNav();

  const footerConfig = {
    theme: theme,
    baseUrl: apiConfig.baseUrl,
    footerBgColor: footerBgColor,
    isSimple: isSimple,
    size
  };

  const initFooterCallback = () => {
    if (window["blockfin-nav-footer"]) {
      window["blockfin-nav-footer"].createFooter({ ...footerConfig, env: "client" });
    }
  };

  useEffect(() => {
    if (sdkUrl.footer) {
      initFooter(initFooterCallback);
    } else {
      if (process.env.NODE_ENV === "development") {
        createFooter(footerConfig);
      }
    }
  }, [sdkUrl.footer, theme]);

  return (
    <div className="blockfin-nav-footer" id="footer">
      <DevFooter
        theme={theme}
        baseUrl={apiConfig.baseUrl}
        footerBgColor={footerBgColor}
        isSimple={isSimple}
        size={size}
      />
    </div>
  );
};

export default NavFooter;
